import script from "./EmailVerificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerificationModal.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerificationModal.vue?vue&type=style&index=0&id=e4f1a21a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4f1a21a"]])

export default __exports__